var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-wrapper" }, [
    _c(
      "div",
      { staticClass: "filter-section" },
      [
        _vm._l(_vm.filters, function(filter) {
          return _c("div", { key: filter.title, staticClass: "filter-item" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-filter align-self-stretch",
                class: { selected: filter.selected },
                on: {
                  click: function($event) {
                    filter.selected = !filter.selected
                    _vm.clearOtherFilters(filter.title)
                  }
                }
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "/assets/images/filters/" + filter.title + "-icon.svg",
                      alt: filter.title
                    }
                  })
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(filter.title))])
              ]
            )
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-filter align-self-stretch",
              class: { selected: !_vm.selectedFilters.length },
              on: {
                click: function($event) {
                  return _vm.clearFilters()
                }
              }
            },
            [_vm._m(0), _vm._v(" "), _c("span", [_vm._v("All")])]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: "/assets/images/filters/all-icon.svg", alt: "all" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }